export default __webpack_public_path__ + "static/media/ApprovalGreenIcon.3e312175.svg";